<script>
import Switches from "vue-switches";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      treatment: []
    }
  },
  components: { Switches },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$axios.get(`/package/${this.$route.params.id}/treatment`)
        .then( response => {  
            this.treatment = response.data.result.treatments 
            console.log(this.treatment)
        })
    },
    cheked(val){
      console.log(val)

    },
    onSubmit() {
      let param = new FormData()
      this.treatment.forEach( item => { 
        if(item.isPresent === true) {  
          param.append('treatments', item.treatmentId)
          param.append('quantities', item.quantity)
        }
      })
      this.$axios.put(`/package/${this.$route.params.id}/treatment`, param)
        .then( () => { 
          Swal.fire("Success", "Package Assign to Treatment Updated Successfully", "success");
          this.fetchData()
        })
    }
  }
}
</script>

<template>
  <div id="edit-location">
    <div class="table-responsive mb-0">
      <table class="table table-hover">
        <thead>
          <tr>
            <th style="width: 5%">No</th>
            <th style="width: 75%">Name</th>
            <th style="width: 10%">Applicable</th>
            <th style="width: 10%">Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in treatment" :key="index">
            <th scope="row">{{ index+1 }}</th>
            <td>{{ item.name }}</td>
            <td>
              <switches v-model="item.isPresent" type-bold="false" color="warning" class="ml-1 mb-0 mt-3"></switches>
            </td>
            <td>
              <input min="0" step="1" type="number" v-model="item.quantity" class="form-control"/>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" @click="onSubmit" class="btn btn-primary m-1 float-right">Submit Change</button>
    </div>
  </div>
</template>